import { render, staticRenderFns } from "./documentSOAI.vue?vue&type=template&id=4d649371&scoped=true"
import script from "./documentSOAI.vue?vue&type=script&lang=js"
export * from "./documentSOAI.vue?vue&type=script&lang=js"
import style0 from "./documentSOAI.vue?vue&type=style&index=0&id=4d649371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d649371",
  null
  
)

export default component.exports